import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=a1b0d368&scoped=true&"
import script from "./Returns.vue?vue&type=script&lang=js&"
export * from "./Returns.vue?vue&type=script&lang=js&"
import style0 from "./Returns.vue?vue&type=style&index=0&id=a1b0d368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b0d368",
  null
  
)

export default component.exports